import baseAPI from '@/http'

const router = 'api/relatorio/relatorioGestaoPagamento'

export const paymentReportManagementAPI = {
  create: (paymentReport) => baseAPI.post(router, paymentReport),
  update: (paymentReport) => baseAPI.put(router, paymentReport),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  listByUser: (filter) => baseAPI.post(`${router}/get-by-usuario`, filter),
  listByFilter: (filter) => baseAPI.post(`${router}/list-by-filtro`, filter),
  analyse: (paymentReport) => baseAPI.put(`${router}` + '/analisar-relatorio', paymentReport),
  receiveEmail: (id) => baseAPI.get(`${router}/send-mail-sgf/${id}`),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  downloadAnexo: (relatorioAnexoId) => baseAPI.post('api/arquivo/anexo/download/' + relatorioAnexoId, null, { responseType: 'blob' }),
  downloadAnexoProcessoPagamento: (relatorioGestaoPagamentoAnexoId) => baseAPI.post('api/arquivo/anexo/download-processo-pagamento/' + relatorioGestaoPagamentoAnexoId, null, { responseType: 'blob' }),

}
